import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CircularProgress, withStyles, Grid } from '@material-ui/core';

class FormButtonContainer extends Component {
    static propTypes = {
        sendLoading: PropTypes.bool,
        buttons: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
        classes: PropTypes.object.isRequired
    };
    static defaultProps = {
        sendLoading: false
    };

    render() {
        let { buttons, classes, sendLoading } = this.props;
        if (!Array.isArray(buttons)) buttons = [buttons];
        return (
            <Grid container className={classes.container} spacing={1} justify="flex-end">
                {sendLoading ? (
                    <Grid item>
                        <CircularProgress size={25} />
                    </Grid>
                ) : (
                    buttons.map(button => (
                        <Grid item key={button.key}>
                            {button}
                        </Grid>
                    ))
                )}
            </Grid>
        );
    }
}

const styles = theme => ({
    container: {
        position: 'absolute',
        top: 50,
        right: 50,
        [theme.breakpoints.down('md')]: {
            top: 30,
            right: 30
        },
        [theme.breakpoints.down('sm')]: {
            top: 20,
            right: 20
        },
        [theme.breakpoints.down('xs')]: {
            top: 18,
            right: 18
        }
    }
});

export default withStyles(styles, { withTheme: true })(FormButtonContainer);



// WEBPACK FOOTER //
// ./data/components/FormButtonContainer.js